export default __webpack_public_path__ + "static/media/R.85836fa3.jpg";